// extracted by mini-css-extract-plugin
export default {"scoreContainer":"ScoreStyles_scoreContainer__Sh9sG","score":"ScoreStyles_score__Gi7hN","leaderboard":"ScoreStyles_leaderboard__kA8Ie"};